import(/* webpackMode: "eager" */ "/app/apps/explore/app/@mapComponents/[locale]/explore/poi/[...slug]/page.tsx");
